/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CandidateCompany from './CandidateCompany';
import Event from './Event';
import Question from './Question';

/**
 * The CandidateOffer model module.
 * @module model/CandidateOffer
 * @version v1
 */
class CandidateOffer {
    /**
     * Constructs a new <code>CandidateOffer</code>.
     * Detalle de oferta con datos de inscripcion si aplican [P_A_03] [P_A_05] [P_A_12]
     * @alias module:model/CandidateOffer
     */
    constructor() { 
        
        CandidateOffer.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateOffer</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateOffer} obj Optional instance to populate.
     * @return {module:model/CandidateOffer} The populated <code>CandidateOffer</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateOffer();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('display_company_name')) {
                obj['display_company_name'] = ApiClient.convertToType(data['display_company_name'], 'Boolean');
            }
            if (data.hasOwnProperty('company')) {
                obj['company'] = CandidateCompany.constructFromObject(data['company']);
            }
            if (data.hasOwnProperty('company_name')) {
                obj['company_name'] = ApiClient.convertToType(data['company_name'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
            if (data.hasOwnProperty('requirements')) {
                obj['requirements'] = ApiClient.convertToType(data['requirements'], 'String');
            }
            if (data.hasOwnProperty('max_jobs')) {
                obj['max_jobs'] = ApiClient.convertToType(data['max_jobs'], 'Number');
            }
            if (data.hasOwnProperty('dept')) {
                obj['dept'] = ApiClient.convertToType(data['dept'], 'String');
            }
            if (data.hasOwnProperty('modality')) {
                obj['modality'] = ApiClient.convertToType(data['modality'], 'String');
            }
            if (data.hasOwnProperty('external_url')) {
                obj['external_url'] = ApiClient.convertToType(data['external_url'], 'String');
            }
            if (data.hasOwnProperty('expire_at')) {
                obj['expire_at'] = ApiClient.convertToType(data['expire_at'], 'String');
            }
            if (data.hasOwnProperty('presence')) {
                obj['presence'] = ApiClient.convertToType(data['presence'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('zip')) {
                obj['zip'] = ApiClient.convertToType(data['zip'], 'String');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('state')) {
                obj['state'] = ApiClient.convertToType(data['state'], 'Number');
            }
            if (data.hasOwnProperty('contract_type')) {
                obj['contract_type'] = ApiClient.convertToType(data['contract_type'], 'Number');
            }
            if (data.hasOwnProperty('length')) {
                obj['length'] = ApiClient.convertToType(data['length'], 'String');
            }
            if (data.hasOwnProperty('schedule')) {
                obj['schedule'] = ApiClient.convertToType(data['schedule'], 'Number');
            }
            if (data.hasOwnProperty('salary_type')) {
                obj['salary_type'] = ApiClient.convertToType(data['salary_type'], 'String');
            }
            if (data.hasOwnProperty('salary_min')) {
                obj['salary_min'] = ApiClient.convertToType(data['salary_min'], 'Number');
            }
            if (data.hasOwnProperty('salary_max')) {
                obj['salary_max'] = ApiClient.convertToType(data['salary_max'], 'Number');
            }
            if (data.hasOwnProperty('benefits')) {
                obj['benefits'] = ApiClient.convertToType(data['benefits'], 'String');
            }
            if (data.hasOwnProperty('benefits_text')) {
                obj['benefits_text'] = ApiClient.convertToType(data['benefits_text'], 'String');
            }
            if (data.hasOwnProperty('academic_programs')) {
                obj['academic_programs'] = ApiClient.convertToType(data['academic_programs'], ['Number']);
            }
            if (data.hasOwnProperty('accept_unfinished')) {
                obj['accept_unfinished'] = ApiClient.convertToType(data['accept_unfinished'], 'Boolean');
            }
            if (data.hasOwnProperty('is_remote_process')) {
                obj['is_remote_process'] = ApiClient.convertToType(data['is_remote_process'], 'Boolean');
            }
            if (data.hasOwnProperty('questions')) {
                obj['questions'] = ApiClient.convertToType(data['questions'], [Question]);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('events')) {
                obj['events'] = ApiClient.convertToType(data['events'], [Event]);
            }
            if (data.hasOwnProperty('responses')) {
                obj['responses'] = ApiClient.convertToType(data['responses'], [Object]);
            }
            if (data.hasOwnProperty('academic_matching')) {
                obj['academic_matching'] = ApiClient.convertToType(data['academic_matching'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateOffer.prototype['id'] = undefined;

/**
 * true: viene el company, false: viene el company_name
 * @member {Boolean} display_company_name
 */
CandidateOffer.prototype['display_company_name'] = undefined;

/**
 * @member {module:model/CandidateCompany} company
 */
CandidateOffer.prototype['company'] = undefined;

/**
 * @member {String} company_name
 */
CandidateOffer.prototype['company_name'] = undefined;

/**
 * @member {String} title
 */
CandidateOffer.prototype['title'] = undefined;

/**
 * @member {String} text
 */
CandidateOffer.prototype['text'] = undefined;

/**
 * @member {String} requirements
 */
CandidateOffer.prototype['requirements'] = undefined;

/**
 * @member {Number} max_jobs
 */
CandidateOffer.prototype['max_jobs'] = undefined;

/**
 * @member {String} dept
 */
CandidateOffer.prototype['dept'] = undefined;

/**
 * normal, fct, dual
 * @member {String} modality
 */
CandidateOffer.prototype['modality'] = undefined;

/**
 * @member {String} external_url
 */
CandidateOffer.prototype['external_url'] = undefined;

/**
 * @member {String} expire_at
 */
CandidateOffer.prototype['expire_at'] = undefined;

/**
 * on_site, semi, remote
 * @member {String} presence
 */
CandidateOffer.prototype['presence'] = undefined;

/**
 * @member {String} date
 */
CandidateOffer.prototype['date'] = undefined;

/**
 * @member {String} zip
 */
CandidateOffer.prototype['zip'] = undefined;

/**
 * @member {String} city
 */
CandidateOffer.prototype['city'] = undefined;

/**
 * Id Provincia
 * @member {Number} state
 */
CandidateOffer.prototype['state'] = undefined;

/**
 * id tipo de contrato
 * @member {Number} contract_type
 */
CandidateOffer.prototype['contract_type'] = undefined;

/**
 * duración del trabajo
 * @member {String} length
 */
CandidateOffer.prototype['length'] = undefined;

/**
 * Id de horario
 * @member {Number} schedule
 */
CandidateOffer.prototype['schedule'] = undefined;

/**
 * bruto año, neto al mes, ...
 * @member {String} salary_type
 */
CandidateOffer.prototype['salary_type'] = undefined;

/**
 * @member {Number} salary_min
 */
CandidateOffer.prototype['salary_min'] = undefined;

/**
 * @member {Number} salary_max
 */
CandidateOffer.prototype['salary_max'] = undefined;

/**
 * array de strings en json
 * @member {String} benefits
 */
CandidateOffer.prototype['benefits'] = undefined;

/**
 * otros beneficios
 * @member {String} benefits_text
 */
CandidateOffer.prototype['benefits_text'] = undefined;

/**
 * lista de ids
 * @member {Array.<Number>} academic_programs
 */
CandidateOffer.prototype['academic_programs'] = undefined;

/**
 * Acepta alumnos que no hayan acabado el ciclo
 * @member {Boolean} accept_unfinished
 */
CandidateOffer.prototype['accept_unfinished'] = undefined;

/**
 * El proceso de selección es todo remoto
 * @member {Boolean} is_remote_process
 */
CandidateOffer.prototype['is_remote_process'] = undefined;

/**
 * @member {Array.<module:model/Question>} questions
 */
CandidateOffer.prototype['questions'] = undefined;

/**
 * unpublished, published, closed
 * @member {String} status
 */
CandidateOffer.prototype['status'] = undefined;

/**
 * esto es para cuando el alumno está inscrito [P_A_12], si no viene null
 * @member {Array.<module:model/Event>} events
 */
CandidateOffer.prototype['events'] = undefined;

/**
 * @member {Array.<Object>} responses
 */
CandidateOffer.prototype['responses'] = undefined;

/**
 * Compatibilidad de academic program
 * @member {Boolean} academic_matching
 */
CandidateOffer.prototype['academic_matching'] = undefined;






export default CandidateOffer;

